<template>
    <div class="crud-area">
        <div class="container-fluid">
            <div class="crud-header d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 class="crud-title">Doações</h2>
                    <p class="crud-subtitle">Listagem e gestão das doações recebidas</p>
                </div>
            </div>

            <div v-if="loading" class="text-center py-5">
                <div class="spinner-border text-primary"></div>
            </div>
            <div v-if="error" class="alert-error mb-3"><i class="ri-error-warning-line"></i> {{ error }}</div>

            <div v-if="!loading" class="crud-card">
                <!-- Totais rápidos -->
                <div class="row g-3 mb-4">
                    <div class="col-sm-4">
                        <div class="stats-mini">
                            <span class="label">Total</span>
                            <span class="value">{{ items.length }}</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="stats-mini">
                            <span class="label">Montante total</span>
                            <span class="value">{{ formatCurrency(totalAmount) }}</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="stats-mini">
                            <span class="label">Concluídas</span>
                            <span class="value">{{ completedCount }}</span>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="crud-table">
                        <thead>
                            <tr>
                                <th>Doador</th>
                                <th>Contactos (Email / Telefone)</th>
                                <th>Mensagem</th>
                                <th>Montante</th>
                                <th>Estado</th>
                                <th>Data</th>
                                <th class="text-end">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="items.length === 0">
                                <td colspan="6" class="text-center text-muted py-4">Sem doações registadas.</td>
                            </tr>
                            <tr v-for="item in items" :key="item.id">
                                <td>
                                    <span v-if="item.isAnonymous" class="text-muted fst-italic">Anónimo</span>
                                    <span v-else>{{ item.donorName || '—' }}</span>
                                </td>
                                <td>
                                    <div class="small">{{ item.donorEmail || 'S/ Email' }}</div>
                                    <div class="text-muted small">{{ item.donorPhone || 'S/ Telefone' }}</div>
                                </td>
                                <td>
                                    <div class="small text-truncate" style="max-width: 150px;" :title="item.message">
                                        {{ item.message || '—' }}
                                    </div>
                                </td>
                                <td class="fw-bold">{{ formatCurrency(item.amount) }}</td>
                                <td>
                                    <span :class="['badge-status', `badge-status--${item.status.toLowerCase()}`]">
                                        {{ statusLabel(item.status) }}
                                    </span>
                                </td>
                                <td>{{ formatDate(item.createdAt) }}</td>
                                <td class="text-end">
                                    <select class="status-select" :value="item.status"
                                        @change="changeStatus(item, $event.target.value)">
                                        <option value="PENDING">Pendente</option>
                                        <option value="COMPLETED">Concluída</option>
                                        <option value="CANCELLED">Cancelada</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import donationsService from '../../services/donationsService';

export default {
    name: 'DonationsContent',
    data() {
        return { items: [], loading: true, error: '' };
    },
    computed: {
        totalAmount() { return this.items.reduce((s, i) => s + i.amount, 0); },
        completedCount() { return this.items.filter(i => i.status === 'COMPLETED').length; },
    },
    mounted() { this.load(); },
    methods: {
        async load() {
            this.loading = true; this.error = '';
            try {
                const res = await donationsService.getAll();
                this.items = res.data || res;
            } catch { this.error = 'Erro ao carregar doações.'; }
            finally { this.loading = false; }
        },
        formatDate(d) { return d ? new Date(d).toLocaleDateString('pt-PT') : '—'; },
        formatCurrency(v) {
            return new Intl.NumberFormat('pt-AO', {
                style: 'currency',
                currency: 'AOA',
            }).format(v).replace('AOA', 'Kz');
        },
        statusLabel(s) {
            const labels = { PENDING: 'Pendente', COMPLETED: 'Concluída', CANCELLED: 'Cancelada' };
            return labels[s] || s;
        },
        async changeStatus(item, status) {
            try {
                await donationsService.update(item.id, { status });
                item.status = status;
            } catch { this.error = 'Erro ao actualizar estado.'; }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../Dashboards/GgmfDashboard/ggmf-card';

.stats-mini {
    background: #F8FAFF;
    border-radius: 16px;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;

    .label {
        font-size: 12px;
        color: #9ca3af;
    }

    .value {
        font-size: 22px;
        font-weight: 700;
        color: #1765FD;
    }
}

.badge-status {
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;

    &--pending {
        background: #FFF3CD;
        color: #856404;
    }

    &--completed {
        background: #D1FAE5;
        color: #065F46;
    }

    &--cancelled {
        background: #FEE2E2;
        color: #991B1B;
    }
}

.status-select {
    border: 1px solid #DFE9FF;
    border-radius: 8px;
    padding: 4px 8px;
    font-size: 12px;
    cursor: pointer;
}
</style>
